import { Component, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService, DeviceSynchedVM } from '../../services/api';
import { color } from 'd3';
import { DatePipe } from '@angular/common';
import { PieChartComponent } from '@swimlane/ngx-charts';


@Component({
	selector: 'devices-synched-report',
	templateUrl: 'devices-synched-report.component.html',
	styleUrls: ['devices-synched-report.component.scss'],
	providers: [DatePipe]
})


export class DevicesSynchedReportComponent implements OnInit, OnChanges {
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [800, 600];
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	view: [number, number] = [600, 550];
	numberOfSynched: number = 0;
	totalDevices: number = 0;
	reportdata :any[] = [];
	showXAxis = true;
	showYAxis = true;
	gradient = false;
	showLegend = false;
	showXAxisLabel = true;
	showYAxisLabel = true;
	yAxisLabel = 'Percentage of Devices Synched';
	xAxisLabel = 'Date Synched';
	customColors: any[] = [];
	currentDate:string = '';
	totalSynched: number = 0;
	totalNotSynched: number = 0;
	startDate: Date = new Date();
	endDate: Date = new Date();

	barChartcustomColors = 
	[
	  { name: "Synched", value: '#95c429' },
	  { name: "Not-Synched", value: '#00aeef' }
	]

	constructor(private service: AnalyticsService, private datePipe: DatePipe) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}


	ngOnInit() { 		
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else{
			this.getProjectReports();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout)
				this.startDate = new Date(today.getTime() - (365 * day));
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
			}
				

			if(this.schoolId != -1){
				this.getSchoolReports()
			}else{
				this.getProjectReports();
			}

	}
		
	}
	
	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	

	onSelectDate(){
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else{
			this.getProjectReports();
		}
	}

	private getSchoolReports(){
		this.service.analyticsGetDeviceSynchedSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			//console.log(data);
			this.prepareData(data)
		});
	}

	private getProjectReports(){
		this.service.analyticsGetDeviceSynchedProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			//console.log(data);
			this.prepareData(data)
		});
	}

	private prepareData(data:any[]){
			this.numberOfSynched = 0
			data.forEach(item =>{
				this.numberOfSynched += item.synchedDevies;
				this.totalDevices = item.totalDevices;
			});
			this.reportdata = [];
			this.reportdata.push(this.getData("Synched", this.numberOfSynched));
			this.reportdata.push(this.getData("Not-Synched", this.totalDevices - this.numberOfSynched));
			console.log(this.reportdata);
			this.customColors = this.barCustomColors();
	}


	private getPercent(num:number, total:number){
		return Math.round((num/total) * 100);
	}



	navigateBack(){
		this.backEvent.next(null);
	}

	getData(day: string, num: number){

		return  {name:day,value:num};
	}

	addMore(data : any[]){
		for(let i:number=0;i<12-data.length;i++){
			let series: any[] = [];
			series.push({name:'Synched',value:0})
			series.push({name:'Not-Synched',value:0})
			data.push({name:' '.repeat(i+1),series:series});
		}
		return data;
	}

	barCustomColors() {
		return [
			{ name: "Synched", value: '#95c429' },
			{ name: "Not-Synched", value: '#00aeef' }
		 ]
	 }
	
	onResize(event:any) {
		this.view = [event.target.innerWidth / 1.35, 400];
	}


}

